export default {
  namespaced: true,

  /**
   * @typedef {Object} item
   * @type {Object}
   * @property {string} item.title - 页面显示的名称
   * @property {string} item.name - 页面路径
   * @typedef {Object} state
   * @type {Object}
   * @property {string} state.editableTabsValue-当前选择的tag
   * @property {item[]} state.menuTabs-所有加入的标签页
   */
  state: {
    editableTabsValue: "/welcome", //当前选择的tag
    menuTabs: [
      {
        title: "欢迎",
        name: "/welcome"
      }
    ]
  },
  actions: {
    /* */
  },
  getters: {
    keepAliveUrl(state) {
      return state.menuTabs
        .map(item => {
          return item.name.slice(1);
        })
        .join(",");
    }
  },
  mutations: {
    UPDATEMENUTABS(state, values) {
      state.editableTabsValue = values;
    },
    /**
     * Description
     * @param {state} state -vuex-home-state数据
     * @param {any} values -需要打开的页面
     */
    ADDTABS(state, values) {
      // 判断当前的标签中是否存在待添加项，避免重复添加
      const haveFlag = state.menuTabs.some(item => {
        return item.name == values.activePath;
      });
      if (!haveFlag) {
        state.menuTabs.push({
          title: values.title,
          name: values.activePath
        });
      }
      state.editableTabsValue = values.activePath;
    },

    /**
     * @param {state} state-页面显示信息 editableTabsValue-当前选中的标签页 menuTabs 所有标签列表
     * @param {string} values-选中的页面的path属性
     * 移除页面
     */
    REMOVETABS(state, values) {
      state.menuTabs = state.menuTabs.filter((item, index) => {
        return item.name != values;
      });
      state.editableTabsValue = state.menuTabs[state.menuTabs.length - 1].name;
    },

    /**
     * Description
     * @param {any} state
     * @param {any} values
     * @returns {any}
     */

    CLEARTABS(state, values) {
      state.menuTabs = [
        {
          title: "欢迎",
          name: "/welcome"
        }
      ];
    }
  }
};
